// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3xHkH","choiceBoxes":"toolbarselects_choiceBoxes__23eAW","simpleField":"toolbarselects_simpleField__7VUO_"};